// extracted by mini-css-extract-plugin
export default {"checkbox":"style_checkbox__j8PHc","label":"style_label__iQDlu"};